import styled from 'styled-components';
import { H2, Text } from '../../elements';

export const ContainerButton = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

export const Title = styled(H2)`
  margin-bottom: 60px;
  text-align: center;
`;

export const Description = styled(Text)`
  margin-top: 30px;
  text-align: center;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputContainer = styled.div`
  margin: 14px 0;
`;
